import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import _ from 'lodash';

import { RectService } from '../../../services/rect.service';
import { Chapter } from '../../../models/chapter';
import { ChapterService } from '../../../services/chapter.service';
import { CommunicationService } from '../../../services/communication.service';
import { Note } from '../../../models/note';
import { PageTextService } from '../../../services/page-text.service';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { SidebarContentComponent } from '../sidebar/sidebar-content-component';
import { Subscription } from 'rxjs';
import { TextSelection } from '../../../models/text-selection';
import { Rect } from '../../../models/rect';
import { NoteInfoBoxComponent } from './note-info-box/note-info-box.component';
import { SidebarSingleNoteComponent } from './sidebar-single-note/sidebar-single-note.component';
import { MainChapterHeadingComponent } from '../../utils/main-chapter-heading/main-chapter-heading.component';
import { SidebarMainchapterNotesComponent } from './sidebar-mainchapter-notes/sidebar-mainchapter-notes.component';

@Component({
    selector: 'sidebar-notes-content',
    templateUrl: './notes-content.component.html',
    styleUrls: ['./notes-content.component.scss'],
    standalone: true,
    imports: [
        NoteInfoBoxComponent,
        SidebarSingleNoteComponent,
        MainChapterHeadingComponent,
        SidebarMainchapterNotesComponent
    ]
})
export class NotesContentComponent implements OnInit, OnDestroy, SidebarContentComponent {

    notes: Array<Note>;
    chapters: Array<Chapter>;
    notesBeforeFirstChapter: Array<Note>;
    notesInChapter: Array<{ chapter: Chapter; notes: Array<Note> }>;
    showDownloadButtons = false;
    noteDownloadLink: string;

    contentChangedSubscription: Subscription;

    constructor(public bookFeatureActivationService: BookFeatureActivationService,
                private rectService: RectService,
                private chapterService: ChapterService,
                private pageTextService: PageTextService,
                private communicationService: CommunicationService,
                private changeDetectorRef: ChangeDetectorRef) {

        this.contentChangedSubscription = this.communicationService.bookFeatureDataChangedAnnouncedSource$.subscribe(ele => {
            if (ele.bookFeature instanceof Rect || ele.bookFeature instanceof TextSelection) {
                this.fetchData();
                this.loadLink();
            }
        });
    }

    ngOnInit(): void {
        this.fetchData();
        this.loadLink();
    }

    ngOnDestroy(): void {
        this.contentChangedSubscription.unsubscribe();
    }

    private loadLink() {
        this.rectService.getRects().then(rects => {
            this.showDownloadButtons = rects.length > 0;
            if (rects.length > 0 && this.bookFeatureActivationService.rectsActivated) {
                this.noteDownloadLink = this.rectService.getExportNotesAsRTFLink();
            }
        });
    }

    private putNoteIntoChapter(chapter, startAndEndIndizes): void {

        const chapterStartAndEndIndizes = startAndEndIndizes;
        let notesInChapter = _.filter(this.notes, note => {
            return note.index >= chapterStartAndEndIndizes[0] && note.index < chapterStartAndEndIndizes[1];
        });
        notesInChapter = _.sortBy(notesInChapter, ele => {
            return ele.index;
        });
        this.notesInChapter.push({ chapter, notes: notesInChapter });

    }

    private handleNotesBeforeFirstChapter(): void {

        let firstChapterIndex = Number.MAX_VALUE;

        if (this.chapters.length >= 1) {
            firstChapterIndex = this.chapters[0].index;
        }

        let notesWithoutChapter = _.filter(this.notes, note => {
            return note && note.index >= 0 && note.index < firstChapterIndex;
        });

        notesWithoutChapter = _.sortBy(notesWithoutChapter, ele => {
            return ele.index;
        });

        this.notesBeforeFirstChapter = notesWithoutChapter;
    }

    private fetchData(): void {

        this.rectService.getRects().then(rects => {
            this.pageTextService.getTextSelections().then(textSelections => {

                this.showDownloadButtons = rects && rects.length > 0;

                this.notes = rects;
                this.notes = this.notes.concat(textSelections);

                this.chapterService.getChapters().then(chapters => {

                    this.chapters = chapters;
                    this.notesInChapter = [];
                    this.handleNotesBeforeFirstChapter();

                    this.chapters.forEach(chapter => {

                        this.chapterService.getMainChapterStartAndEndIndex(chapter).then(indizes => {

                            this.putNoteIntoChapter(chapter, indizes);

                        });
                        this.changeDetectorRef.reattach();
                    });
                });
            });
        });
    }
}
